var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useState } from 'react';
import { getSafeEventHandlerOpts } from '../utils/touchEvent';
var TOUCH_EVENT_OPTIONS = getSafeEventHandlerOpts({
    capture: true,
    passive: false,
});
export var useHiddenBodyOverflow = function (shouldLockScroll) {
    useEffect(function () {
        if (shouldLockScroll) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.removeProperty('overflow');
        }
        // hooray for ie 11, not supporting Event constructor
        var event;
        if (typeof UIEvent === 'function') {
            event = new UIEvent('resize');
        }
        else {
            event = document.createEvent('UIEvent');
            event.initEvent('resize', true, true);
        }
        window.dispatchEvent(event);
    }, [shouldLockScroll]);
};
export var useTrackScrollPosition = function (ref) {
    var _a = __read(useState({ x: 0, y: 0 }), 2), scrollPosition = _a[0], setScrollPosition = _a[1];
    var onScroll = useCallback(function (event) {
        var _a = event.target, y = _a.scrollTop, x = _a.scrollLeft;
        setScrollPosition({ x: x, y: y });
    }, []);
    useEffect(function () {
        if (ref) {
            ref.addEventListener('scroll', onScroll, TOUCH_EVENT_OPTIONS);
        }
        return function () {
            if (ref) {
                ref.removeEventListener('scroll', onScroll, TOUCH_EVENT_OPTIONS);
            }
        };
    }, [ref]);
    return scrollPosition;
};
